<template>
  <div class="px-10 py-11">
    <w-button
      class="prev-page"
      type="text"
      @click="goBack"
    >
      <i class="icon-chevron-left-bold" />
      返回一起訂東西
    </w-button>
    <order-overview class="mt-6" :order-id="orderId" />
  </div>
</template>

<script>
import OrderPreview from './OrderPreview';

export default OrderPreview;
</script>

<style lang="scss" scoped>
@import "./OrderPreview";
</style>
